'use strict';
import * as $j_app$002eapi$002e$002dDrug$002dRequests$002dAccepted$002dList$002dItem$0024$002dId$0024 from "./app.api.-Drug-Requests-Accepted-List-Item$-Id$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_PharmacyAppUpdate$$anon$119() {
}
export { $c_Lapp_api_PharmacyAppUpdate$$anon$119 as $c_Lapp_api_PharmacyAppUpdate$$anon$119 };
$c_Lapp_api_PharmacyAppUpdate$$anon$119.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_PharmacyAppUpdate$$anon$119.prototype.constructor = $c_Lapp_api_PharmacyAppUpdate$$anon$119;
/** @constructor */
function $h_Lapp_api_PharmacyAppUpdate$$anon$119() {
}
export { $h_Lapp_api_PharmacyAppUpdate$$anon$119 as $h_Lapp_api_PharmacyAppUpdate$$anon$119 };
$h_Lapp_api_PharmacyAppUpdate$$anon$119.prototype = $c_Lapp_api_PharmacyAppUpdate$$anon$119.prototype;
$c_Lapp_api_PharmacyAppUpdate$$anon$119.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_PharmacyAppUpdate$$anon$119.prototype.apply__O = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_tapir$package$().given_Schema_NonEmptySet__Lsttp_tapir_Schema__Lsttp_tapir_Schema($j_app$002eapi$002e$002dDrug$002dRequests$002dAccepted$002dList$002dItem$0024$002dId$0024.$m_Lapp_api_DrugRequestsAcceptedListItem$Id$().derived$Schema__Lsttp_tapir_Schema());
});
var $d_Lapp_api_PharmacyAppUpdate$$anon$119 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_PharmacyAppUpdate$$anon$119, "app.api.PharmacyAppUpdate$$anon$119", ({
  Lapp_api_PharmacyAppUpdate$$anon$119: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_PharmacyAppUpdate$$anon$119 as $d_Lapp_api_PharmacyAppUpdate$$anon$119 };
//# sourceMappingURL=app.api.-Pharmacy-App-Update$$anon$119.js.map
